<template>
  <div>
    <div v-if="!$vuetify.breakpoint.xsOnly" class="d-flex">
      <div
        style="width: 230px"
        v-for="(item, i) in groups"
        :key="i.id"
        class="mr-3"
        cols="12"
        sm="12"
        md="4"
        @click="
          item.is_admin || $route.name == 'HomePage'
            ? openGroup(item.group_type, item.id)
            : ''
        "
        :style="
          item.is_admin || $route.name == 'HomePage' ? 'cursor: pointer;' : ''
        "
      >
        <v-card
          class="main-card"
          :height="
            !item.is_admin && $route.name != 'HomePage' ? '298px' : '240px'
          "
          style="border-radius: 12px"
        >
          <v-card-text class="px-0 pt-0">
            <div style="position: relative">
              <v-img
                class="cover-image"
                height="110px"
                :src="item.cover_image ? item.cover_image : group_cover"
              >
                <div class="user-icons">
                  <v-img
                    class="user-img-badge"
                    :src="getIcons(item.group_type)"
                  >
                  </v-img>
                </div>
                <div
                  v-if="item.group_type == 'Premium'"
                  class="user-badge d-flex justify-end align-center"
                >
                  <span class="sebi-ria">
                    <span v-if="item.admin_payment_info" class="">
                      SEBI
                      {{
                        getSebi(item.admin_payment_info.profile.sebi_user_type)
                      }}
                    </span>
                  </span>
                </div>
              </v-img>
            </div>
          </v-card-text>
          <v-card-text
            style="height: 100%"
            class="d-flex justify-space-between flex-column px-3 pt-0 pb-2"
          >
            <div>
              <div class="group-header">{{ item.name }}</div>
              <div v-if="item.admin" class="group-subheader">
                By {{ item.admin.profile.name }}
              </div>
            </div>
            <div v-if="item.group_type == 'Premium'">
              <div class="d-flex pb-1">
                <v-chip-group
                  v-for="(inst, i) in getIntruments(item.types_of_instrument)"
                  :key="i.id"
                  multiple
                  class="px-0"
                  mandatory
                >
                  <v-chip
                    class="px-1 py-2"
                    x-small
                    active
                    :color="getColor(i)"
                    label
                    outlined
                  >
                    <span class="intru-txt"> {{ inst }} </span>
                  </v-chip>
                </v-chip-group>
              </div>
              <div class="d-flex pb-2 justify-space-between">
                <div class="details">
                  <div v-if="item.metrics.closed_trades">
                    {{ item.metrics.closed_trades }}
                  </div>
                  <div v-else>-</div>
                  <div>Avg. Trades</div>
                </div>
                <div class="details">
                  <div v-if="item.metrics.accuracy">
                    {{ item.metrics.accuracy }}%
                  </div>
                  <div v-else>-</div>
                  <div>Accuracy</div>
                </div>
                <div class="details">
                  <div v-if="item.metrics.avg_trade_return">
                    {{ item.metrics.avg_trade_return }}%
                  </div>
                  <div v-else>-</div>
                  <div>Avg. Returns</div>
                </div>
              </div>
            </div>
            <div v-else>
              <!-- Members -->
              <div class="d-flex align-baseline">
                <span>
                  <v-img class="group-trades mr-2" :src="Group"></v-img>
                </span>
                <span class="members-count mr-1">
                  {{ item.participants_count }}
                </span>
                <span class="members-trades-title">Members</span>
              </div>
              <!-- Trades Count -->
              <div class="d-flex align-baseline">
                <span>
                  <v-img class="group-trades mr-2" :src="Trades"></v-img>
                </span>
                <span class="members-count mr-1">
                  {{ item.trades_count }}
                </span>
                <span class="members-trades-title">Posted Trades</span>
              </div>
            </div>
          </v-card-text>
          <v-card-actions
            v-if="!item.is_admin && $route.name != 'HomePage'"
            class="card-actions"
          >
            <v-btn
              @click="openGroup(item.group_type, item.id)"
              block
              class="group-btn"
              height="36px"
              :outlined="item.is_participant"
              color="primary"
            >
              {{ btnText(item.group_type, item.is_participant) }}</v-btn
            >
          </v-card-actions>
        </v-card>

        <div
          v-if="item.group_type === 'Premium'"
          class="d-flex justify-center pt-1"
        >
          <v-chip
            v-if="
              !item.is_admin_payment_info ||
              item.admin_payment_info.verification_status === 'Pending'
            "
            class="Pending mx-2 d-flex"
          >
            <div>
              <v-icon size="15" color="#f2994a">mdi-alert-outline</v-icon>
            </div>
            <span class="pt-1 pl-1">Pending</span>
          </v-chip>
          <v-chip
            v-else-if="
              item.admin_payment_info.verification_status === 'Rejected'
            "
            class="Rejected mx-2 d-flex"
          >
            <div>
              <v-icon size="15" color="#eb5757"
                >mdi-alert-circle-outline</v-icon
              >
            </div>
            <span class="pt-1 pl-1">Rejected</span>
          </v-chip>
        </div>
      </div>
    </div>
    <div v-else>
      <v-row class="mb-1">
        <v-col
          class="pb-0"
          cols="12"
          sm="12"
          v-for="(item, i) in getGroups()"
          :key="i.id"
        >
          <v-card
            @click="openGroup(item.group_type, item.id)"
            style="border-radius: 12px"
            height="125px"
          >
            <v-card-text class="d-flex pa-0">
              <div>
                <v-img
                  height="125px"
                  width="94px"
                  :src="item.picture ? item.picture : mobile_cover_image"
                >
                  <div class="user-icons">
                    <v-img
                      class="user-img-badge"
                      :src="getIcons(item.group_type)"
                    >
                    </v-img>
                  </div>

                  <div v-if="item.group_type == 'Premium'" class="user-badge">
                    <span class="sebi-ria-mobile">
                      <span v-if="item.admin_payment_info" class="">
                        SEBI
                        {{
                          getSebi(
                            item.admin_payment_info.profile.sebi_user_type
                          )
                        }}
                      </span>
                    </span>
                  </div>
                </v-img>
              </div>
              <div style="width: 100%" class="py-2 px-3">
                <div
                  style="height: 100%"
                  class="d-flex justify-space-between flex-column"
                >
                  <div>
                    <div class="group-header">{{ item.name }}</div>
                    <div v-if="item.admin" class="group-subheader">
                      By {{ item.admin.profile.name }}
                    </div>
                  </div>
                  <div v-if="item.group_type == 'Premium'">
                    <div class="d-flex pb-1">
                      <v-chip-group
                        v-for="(inst, i) in getIntruments(
                          item.types_of_instrument
                        )"
                        :key="i.id"
                        multiple
                        class="px-0"
                        mandatory
                      >
                        <v-chip
                          class="px-1 py-2"
                          x-small
                          active
                          :color="getColor(i)"
                          label
                          outlined
                        >
                          <span class="intru-txt"> {{ inst }} </span>
                        </v-chip>
                      </v-chip-group>
                    </div>
                    <div class="d-flex pb-2 justify-space-between">
                      <div class="details">
                        <div v-if="item.metrics.closed_trades">
                          {{ item.metrics.closed_trades }}
                        </div>
                        <div v-else>-</div>
                        <div>Avg. Trades</div>
                      </div>
                      <div class="details">
                        <div v-if="item.metrics.accuracy">
                          {{ item.metrics.accuracy }}%
                        </div>
                        <div v-else>-</div>
                        <div>Accuracy</div>
                      </div>
                      <div class="details">
                        <div v-if="item.metrics.avg_trade_return">
                          {{ item.metrics.avg_trade_return }}%
                        </div>
                        <div v-else>-</div>
                        <div>Avg. Returns</div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <!-- Members -->
                    <div class="d-flex align-baseline">
                      <span>
                        <v-img class="group-trades mr-2" :src="Group"></v-img>
                      </span>
                      <span class="members-count mr-1">
                        {{ item.participants_count }}
                      </span>
                      <span class="members-trades-title">Members</span>
                    </div>
                    <!-- Trades Count -->
                    <div class="d-flex align-baseline">
                      <span>
                        <v-img class="group-trades mr-2" :src="Trades"></v-img>
                      </span>
                      <span class="members-count mr-1">
                        {{ item.trades_count }}
                      </span>
                      <span class="members-trades-title">Posted Trades</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-if="$route.name == 'ProfilePage'" class="mt-2" cols="12">
          <div @click="openViewAll()" class="view-all-groups">
            View All Groups
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import commonFunctions from "@/common/commonFunctions";

export default {
  name: "MGroupProfileHorizontalList",

  props: {
    groups: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      commonFun: commonFunctions,

      loading: false,
      // image
      group_cover: require("@/assets/images/myGroupCoverImage.svg"),
      mobile_cover_image: require("@/assets/images/mobile_cover_image.svg"),
      // icons
      privacy: require("@/assets/images/privacy.svg"),
      premium_badge: require("@/assets/images/premium_badge.svg"),
      Group: require("@/assets/images/Groups.svg"),
      Globe: require("@/assets/images/globe.svg"),
      Trades: require("@/assets/images/trades.svg"),
    };
  },

  methods: {
    openViewAll() {
      this.$router.push({
        name: "allGroups",
        params: {
          id: this.$route.params.id || this.commonFun.getUserId(),
        },
      });
    },
    getGroups() {
      return this.groups.slice(0, 3);
    },
    getSebi(item) {
      if (item == "registered_analyst") {
        return "RA";
      } else {
        return "RIA";
      }
    },
    getColor(i) {
      const colorMap = ["#459393", "#3F7BC3", "#DD9324"];
      return colorMap[i] || "#333333CC"; // Fallback color
    },

    getIcons(type) {
      switch (type) {
        case "Public":
          return this.Globe;
        case "Private":
          return this.privacy;
        default:
          return this.premium_badge;
      }
    },

    openGroup(type, id) {
      if (type == "Premium") {
        this.$router.push({
          name: "premiumGroup",
          params: {
            id: id,
          },
        });
      } else {
        this.$router.push({
          name: "GroupDetails",
          params: {
            id: id,
          },
        });
      }
    },
    btnText(type, isJoin) {
      if (type == "Premium" || type == "Public") {
        return isJoin ? "View Group" : "Join Group";
      } else if (type == "Private") {
        return isJoin ? "View Group" : "Send Request";
      }
    },
    getIntruments(instrument) {
      if (instrument.length >= 3) {
        return instrument.pop();
      } else {
        return instrument;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .user-icons {
    position: absolute;
    left: 5px;
    right: auto !important;
    margin-top: 6px;
  }
  .user-img-badge {
    width: 12px !important;
    height: 12px !important;
  }
  .user-badge {
    top: 0px !important;
    right: 8px !important;
    left: auto !important;
  }
  .sebi-ria-mobile {
    font-family: Avenir;
    font-size: 9px;
    font-weight: 800;
    line-height: 12.29px;
    text-align: left;
    color: linear-gradient(180deg, #4469b1 0%, #1d2c4b 100%);
  }
  .view-all-groups {
    font-family: Avenir;
    font-size: 14px;
    font-weight: 800;
    line-height: 19.12px;
    text-align: center;
    color: #2d8cff;
  }
  .user-name {
    height: 159px !important;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    width: 108px !important;
  }
  .user-name > div {
    font-size: 35px !important;
  }
  .user-image {
    height: 159px !important;
    width: 108px !important;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .sebi-ra-mobile {
    position: absolute;
    padding: 5px;
    font-family: Avenir;
    font-size: 9px;
    font-weight: 500;
    line-height: 5px;
    text-align: left;
    // height: 12px;
    border-radius: 4px;
    bottom: 8px;
    left: 55px;
    display: inline;
    border: 0.5px solid;
    background: linear-gradient(
      87.32deg,
      rgba(68, 105, 177, 0.8) 0%,
      rgba(111, 155, 239, 0.8) 100%
    );
    color: #fff;
    border-image-source: linear-gradient(180deg, #4469b1 0%, #1d2c4b 100%);
  }
  .details > div:nth-child(2) {
    font-family: Avenir;
    font-size: 11px !important;
    font-weight: 500;
    line-height: 13.66px;
    text-align: left;
    color: #333333b8;
  }
  .user-img-badge {
    height: 18px;
    width: 18px;
    margin-right: 0 !important;
  }
}
.group-trades {
  width: 15.31px;
  height: 10.53px;
}
.members-trades-title {
  font-family: Avenir;
  font-size: 12.5px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #333333b8;
}
.members-count {
  font-family: Avenir;
  font-size: 19px;
  font-weight: 800;
  line-height: 24.59px;
  text-align: left;
  color: #333333eb;
}
.user-name {
  background-color: #add8e6;
  color: #333333;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-name > div {
  font-size: 22px;
}

.discount-price {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 800;
  line-height: 15.03px;
  text-align: left;
  color: #333333;
}
.cover-image {
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
}
.discount-percent {
  color: #27b568;
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  //   line-height: 12.29px;
  text-align: left;
}
.discount-strike {
  text-decoration: line-through;
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  //   line-height: 12.29px;
  text-align: left;
  color: #33333370;
}
.intru-txt {
  padding: 3px;
  font-family: Avenir;
  font-size: 11.5px;
  font-weight: 500;
  line-height: 10.93px;
  text-align: left;
}
.group-header {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 800;
  line-height: 19.12px;
  text-align: left;
  color: #333333;
}
.group-subheader {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 500;
  line-height: 13.66px;
  text-align: left;
  color: #33333399;
}
.subscribe {
  font-family: Avenir;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.39px;
  text-align: center;
}
.group-btn {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 800;
  line-height: 16.39px;
  text-align: center;
  border-radius: 8px;
  text-transform: capitalize;
}
.sebi-ria {
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  line-height: 13.66px;
  text-align: left;
  color: #fff;
  background: linear-gradient(
    87.32deg,
    rgba(68, 105, 177, 0.8) 0%,
    rgba(111, 155, 239, 0.8) 100%
  );
  border: 0.5px solid;
  border-radius: 4px;
  border-image-source: linear-gradient(180deg, #4469b1 0%, #1d2c4b 100%);
  padding: 3px;
  // padding: 2.2px;
  // font-family: Avenir;
  // font-size: 9px;
  // font-weight: 500;
  // line-height: 12px;
  // text-align: left;
  // color: transparent;
  // background: linear-gradient(180deg, #4469b1 0%, #1d2c4b 100%);
  // border-radius: 4px;
  // -webkit-background-clip: text;
  // background-clip: text;
  // border: 1.33px solid black;
}

.user-img-badge {
  width: 18px;
  height: 18px;
  margin-left: auto;
  // margin-right: 10px;
  // margin-top: 8px;
}
.user-badge {
  position: absolute;
  bottom: 5px;
  right: 3px;
  // height: 18px;
  // margin-top: 8px;
}
.main-card {
  display: flex;
  flex-direction: column;
}
.card-actions {
  margin-top: auto;
  // position: absolute;
  // bottom: 10px;
}
.user-abs {
  position: absolute;
  bottom: -25px;
  left: 10px;
}
.user-icons {
  position: absolute;
  right: 6px;
  margin-top: 6px;
}
.user-image {
  width: 60px;
  height: 60px;
  border-radius: 4px;
}
.title-txt {
  font-family: Avenir;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 10.55px;
}
.details {
  text-align: center;
}
.details > div:first-child {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 800;
  line-height: 17.76px;
  color: #333333;
}
.details > div:nth-child(2) {
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  line-height: 13.66px;
  text-align: left;
  color: #333333b8;
}
.br-radius {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.dashed-border {
  box-sizing: border-box;
  border-bottom: 2px dashed #e4e4e4;
}
.title {
  //   text-align: left;
  height: 17px;
  background: linear-gradient(
    102.19deg,
    #d2c081 0%,
    #feeeb6 53.13%,
    #d3bb65 100%
  );
}
</style>
